import { JobLineItem } from "../@types/job";
import { isServiceLineItem, isSpecimenLineItem } from "./lineItem";

export function stripProcessingFeeServiceNameFromLineItems(
  lineItems: JobLineItem[]
): JobLineItem[] {
  return lineItems.map((item) => {
    if (isSpecimenLineItem(item)) {
      return item;
    }

    if (isServiceLineItem(item) && !item.service.includes("Processing Fee")) {
      return item;
    }

    try {
      const parsedNotes = JSON.parse(item.notes);
      const processingFeeName = parsedNotes.name;
      const suffixToRemove = processingFeeName.replace("Processing Fee", "");

      return {
        ...item,
        service: item.service.replace(suffixToRemove, ""),
      };
    } catch (error) {
      return item;
    }
  });
}
